import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const NotFound: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('notFoundHeadTitle')}</title>
      </Helmet>
      <div>Not Found</div>
    </>
  );
};

export default NotFound;
